export const CURRENT_CONFIG = {

  // license
  appId: '142402', // You need to go to the development website to apply.
  appKey: 'bde3b53cdd8f159b1bf26c429f4395c', // You need to go to the development website to apply.
  appLicense: 'npEMfbonYv7iM8F+AB/vUW8fBUBUrKIYvwX0uGU7nufgpjIb8lZrsKSLfSxJuZGb3+yeTJeQeFsMeMesqyqDD8KevcH0v/cGDWkKi4SLc5RVtDmMzqct0JGTOOix717ulWXmDsMc8zUTnlY7Xwp8RdWQ+GLUSzIGIo/JrxoGi9w=', // You need to go to the development website to apply.

  // http
  baseURL: 'http://uav.wangshan.com.cn/ht/js/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  // websocketURL: 'ws://192.168.11.90:8980/js/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'
  // wss://uav.wangshan.com.cn/js/api/v1/ws
  websocketURL: 'wss://uav.wangshan.com.cn/ht/js/api/v1/ws',
  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  // rtmpURL: 'rtmp://uav.wangshan.com.cn:1935/live/', // Example: 'rtmp://192.168.1.1/live/'
  // rtmpURL: 'rtmp://119.3.178.54:1935/live/', // Example: 'rtmp://192.168.1.1/live/'
  rtmpURL: 'rtmp://uav.wangshan.com.cn:1935/live/', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
